import React, { useEffect, useState, useCallback } from "react";
import { IoArrowBackOutline } from "react-icons/io5";
import { FaCheckCircle } from "react-icons/fa";
import { FaMagnifyingGlass } from "react-icons/fa6";
import { useGetDatasourceQuery } from "./sql/TablesourceApiSlice";
import { RiAdminFill } from "react-icons/ri";
import DropDownComp from "../../components/DropDownComp";

import { FaDatabase } from "react-icons/fa6";
import { FaSort } from "react-icons/fa";
import { FaIoxhost } from "react-icons/fa";
import { useDispatch, useStore } from "react-redux";
import { setDataSource, setWorkbookData } from "../reduxworkbook/WorkbookSlice";
import NewDataSources from "./NewDataSources";
import useAuth from "../../hooks/useAuth";
import {
  useCreateSheetMutation,
  useGetSearchDataSourcesQuery,
} from "./generalApiSlice";
import debounce from "lodash/debounce";
import { useNavigate } from "react-router-dom";
import { setInitialState } from "../reduxworkbook/WorkbookSlice";
import useTitle from "../../hooks/useTitle";
import { format } from "date-fns";
import { ConnectsqlForm } from "./ConnectsqlForm";
import { IoMdClose } from "react-icons/io";
import LoadingIndicator from "../../components/BasicComponents/LoadingIndicator";

export default function Datasource() {
  useTitle("Vizta Datasources");

  const [showPopup, setShowPopup] = useState(false);
  const [selectedRow, setSelectedRow] = useState(0);
  console.log(selectedRow);
  const [selectedDataSourceID, setSelectedDataSourceID] = useState();
  const [sortBy, setSortBy] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");
  const [sortedData, setSortedData] = useState([]);
  const dispatch = useDispatch();
  let tableContent = null;
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const navigate = useNavigate();
  const { roles, username } = useAuth();
  // search api
  const {
    data: searchedData,
    isSuccess: isSearchSuccess,
    isError: isSearchError,
    error: searchError,
    refetch,
  } = useGetSearchDataSourcesQuery(
    { value: debouncedSearchTerm },
    {
      skip: !debouncedSearchTerm,
    }
  );

  console.log(roles);
  console.log(username);

  console.log(searchedData);
  // databases
  const {
    data: databaseConnections = [],
    error: queryError,
    isLoading,
    isSuccess,
    isError,
  } = useGetDatasourceQuery();
  // console.log(databaseConnections);

  const [
    createSheet,
    {
      data,
      isSuccess: isCreateSheetSuccess,
      isLoading: isCreateSheetLoading,
      isError: isCreateSheetError,
      error: createSheeterror,
    },
  ] = useCreateSheetMutation({});

  // if (isCreateSheetSuccess) {
  //   console.log(isCreateSheetSuccess);
  //   console.log(data);
  //   const workbookId = data["populatedWorkbook"]["_id"];
  //   const sheetId = data["populatedWorkbook"]["sheets"][0]["_id"];
  //   console.log(workbookId);
  //   // console.log(sheetId);
  //   navigate(`/workbook?workbookid=${workbookId}`);
  // }
  useEffect(() => {
    if (isCreateSheetSuccess && data) {
      console.log(isCreateSheetSuccess);
      console.log(data);

      const workbookId = data?.populatedWorkbook?._id;
      const sheetId = data?.populatedWorkbook?.sheets?.[0]?._id;

      console.log(workbookId);
      // console.log(sheetId);
      dispatch(setWorkbookData(data["populatedWorkbook"]));
      if (workbookId) {
        navigate(`/workbook?workbookid=${workbookId}`);
      }
    }
  }, [isCreateSheetSuccess, data, navigate]);

  const store = useStore();
  const handleConnect = () => {
    dispatch(setInitialState());
    const value = store.getState();
    console.log(value.Workbook.present);
    const workBookId = value.Workbook.present._id;
    console.log(workBookId);
    // Save workBookId to sessionStorage
    sessionStorage.setItem("workBookId", workBookId);
    // Call createSheet with the current state
    createSheet(value.Workbook.present);
  };

  const handleDoubleClick = () => {
    handleConnect();
  };

  if (isCreateSheetError) {
    if (createSheeterror.status === 400) {
      const _id = dispatch(setInitialState());
      console.log(selectedDataSourceID);
      dispatch(
        setDataSource({ dataSourceID: selectedDataSourceID, initial: true })
      );
      // this means we cannot save already saved workbook, we need to clear the session rebuild the redux initial state and reset the session storage
      handleConnect();
    }
  }

  useEffect(() => {
    const sortData = () => {
      const newData = [...databaseConnections].sort((a, b) => {
        if (sortBy === "AddedOn") {
          const dateA = new Date(a[sortBy]);
          const dateB = new Date(b[sortBy]);
          if (sortOrder === "asc") {
            return dateA - dateB;
          } else {
            return dateB - dateA;
          }
        }

        return 0;
      });
      setSortedData(newData);
      console.log(newData);
    };

    if (isSuccess && databaseConnections) {
      sortData(); // Sort when data is fetched or updated
    }
  }, [isSuccess, databaseConnections, sortBy, sortOrder]);

  let items = debouncedSearchTerm
    ? searchedData === null
      ? []
      : Array.isArray(searchedData)
      ? searchedData
      : sortedData
    : sortedData;

  console.log(items);

  let localDataSources = [];
  const superStoreDataSorceItem = items.filter((dItem) =>
    ["67c6d45234a9249ad0a4e131", "6720aafb500033fe2a8695de"].includes(dItem.id)
  );
  localDataSources = [
    ...superStoreDataSorceItem,
    ...items.filter((dItem) => dItem.Owner === username),
  ];
  items = localDataSources;
  console.log(items);

  useEffect(() => {
    if (isSuccess && selectedRow !== null && selectedRow !== undefined) {
      const dataSourceID = items[selectedRow]?.["id"];
      console.log(dataSourceID, selectedRow, items[selectedRow]);

      sessionStorage.setItem("dataSourceID", dataSourceID);
      if (dataSourceID) {
        setSelectedDataSourceID(dataSourceID);
        dispatch(setDataSource({ dataSourceID, initial: true }));
      }
    }
  }, [selectedRow, isSuccess]);

  const handleSort = () => {
    if (sortBy === "AddedOn") {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortBy("AddedOn");
      setSortOrder("asc");
    }
  };

  // Debounce the search term update
  const debouncedSetSearchTerm = useCallback(
    debounce((value) => setDebouncedSearchTerm(value), 300),
    []
  );

  const handleSearchColumn = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    debouncedSetSearchTerm(value);
  };

  // useEffect(() => {
  //   console.log("im called");
  //   dispatch(setInitialState());
  // }, []);

  if (isLoading) {
    tableContent = <LoadingIndicator />;
  }
  if (isError) {
    tableContent = (
      <div className="text-center">
        Error while fetching datasources: {queryError?.message}
      </div>
    );
  }

  if (isSuccess) {
    if (isSearchError) {
      console.error(searchError);
    }

    const defaultDatabaseId = items[0]?.id;
    if (defaultDatabaseId && selectedRow === 0) {
      dispatch(
        setDataSource({ dataSourceID: defaultDatabaseId, initial: true })
      );
    }

    // console.log(items);

    tableContent = (
      <tbody className="overflow-auto px-6 py-2 w-full">
        {isSearchError ? (
          <p>{searchError.data.message}</p>
        ) : isLoading ? (
          <LoadingIndicator />
        ) : (
          items.map((connection, index) => {
            if (Object.keys(connection).length > 0) {
              return (
                <tr
                  key={index}
                  className={`cursor-pointer flex justify-between w-full rounded gap-y-4 border mb-[2px]
                  ${
                    selectedRow === index
                      ? "bg-blue-950 text-white"
                      : index % 2 === 0
                      ? "bg-none text-black"
                      : "bg-gray-200"
                  } 
                `}
                  onClick={() => setSelectedRow(index)}
                  onDoubleClick={handleDoubleClick}
                >
                  <td className="truncate text-left border-none w-[20%] pl-[5.5%]">
                    {connection.NickName}
                  </td>
                  <td className="truncate text-left border-none w-[20%] pl-[6.5%]">
                    {connection.DataBaseName}
                  </td>
                  <td className="truncate text-left border-none w-[20%] pl-[10.7%]">
                    {connection.Owner}
                  </td>
                  <td className="truncate text-left border-none w-[20%] pl-[9.7%]">
                    {connection.Host}
                  </td>
                  <td className="truncate text-left border-none w-[20%] pl-[6%]">
                    {connection.AddedOn
                      ? format(
                          new Date(connection.AddedOn),
                          "MMMM dd, yyyy h:mm a"
                        )
                      : ""}
                  </td>
                </tr>
              );
            } else {
              return (
                <tr
                  key={index}
                  className={`flex justify-center items-center w-full rounded gap-y-4 border mb-[2px] h-[1.5rem]
                  ${index % 2 === 0 ? "bg-none text-black" : "bg-gray-200"} 
                `}
                ></tr>
              );
            }
          })
        )}
      </tbody>
    );
  }
  return (
    <>
      <section
        className={`flex flex-col overflow-hidden overflow-y-auto h-screen ${
          showPopup ? "opacity-60" : ""
        }`}
      >
        {/* HeaderSection */}
        <header className="w-full h-[5%] gap-2 flex items-center justify-between border-transparent px-2 rounded-none bg-blue-950 text-white text-xl">
          <button
            className="flex items-center justify-center gap-1"
            onClick={() => navigate("/home/dash")}
          >
            <IoArrowBackOutline />
            <strong>Home</strong>
          </button>
          <DropDownComp />
        </header>

        {/* Body section */}
        <section
          className={`flex flex-col gap-2 items-start justify-start w-full pl-[1.9%] ${
            roles.includes("Explorer") ? "h-[92.5%]" : "h-[70%]"
          }`}
        >
          <h2 className="w-full text-left text-2xl font-medium">
            Saved Data Sources
          </h2>
          <div className="flex items-center justify-start w-full relative -left-[1%]">
            <FaMagnifyingGlass className="relative left-5 text-md text-gray-200" />
            <input
              type="text"
              placeholder="search the data sources..."
              onChange={handleSearchColumn}
              value={searchTerm}
              className="w-[18%] border-2 rounded px-5  text-black outline-none"
            />
          </div>
          <div className="w-[90%] flex justify-end items-center">
            {isCreateSheetLoading ? <LoadingIndicator /> : null}
            {isCreateSheetError ? createSheeterror.data?.message : null}
            <button
              className={`cursor-pointer border rounded py-1 px-2 font-medium ${
                selectedRow !== null
                  ? "bg-blue-950 text-white"
                  : "bg-gray-200 text-black"
              }`}
              disabled={selectedRow === null}
              onClick={handleConnect}
            >
              Connect
            </button>
          </div>
          {/* ${roles.includes("Explorer") ? "h-full" : "h-[70%]"} */}
          <table
            className={`shadow-xl border-t-2 border-b w-[90%] ${
              roles.includes("Explorer") ? "h-full" : "h-[70%]"
            } rounded-lg border-gray-900 flex flex-col overflow-x-auto`}
          >
            {/* <div className="pt-2"> */}
            <thead className="flex items-center justify-around w-full pb-2 border-b-2 px-2">
              <th className="flex gap-2 items-center justify-center font-bold">
                <FaCheckCircle />
                NickName
              </th>
              <th className=" flex gap-2 items-center justify-center font-bold">
                <FaDatabase />
                DataBaseName
              </th>
              <th className=" flex gap-2 items-center justify-center font-bold">
                <RiAdminFill />
                Owner
              </th>
              <th className=" flex gap-2 items-center justify-center font-bold">
                <FaIoxhost />
                Host
              </th>
              <th
                className="flex gap-2 items-center justify-center cursor-pointer font-bold relative right-4"
                onClick={handleSort}
              >
                <FaSort />
                AddedOn
              </th>
            </thead>
            {/* </div> */}

            {tableContent}
          </table>
        </section>

        {roles.includes("Explorer") ? null : (
          <NewDataSources setShowPopup={setShowPopup} />
        )}
      </section>
      {showPopup ? (
        <main className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <section className="w-[22rem] h-auto bg-white flex flex-col items-center justify-start rounded z-10">
            <header className="flex w-full items-center justify-between bg-blue-950 px-2 py-1 text-white">
              My SQL
              <IoMdClose
                onClick={() => setShowPopup(false)}
                className="cursor-pointer"
              />
            </header>
            <ConnectsqlForm closeModal={() => setShowPopup(false)} />
          </section>
        </main>
      ) : null}
    </>
  );
}
